<template>
    <ContentOrLoading>
        <ShowSvgSectionComponent
            v-if="svg"
            :seccion="seccion"
            :zona_id="zona_id"
            :svg="svg"
            :zonas="zonas"
            @clickZona="clickRegion"
        />
    </ContentOrLoading>
</template>

<script>
    import ShowSvgSectionComponent from '@/components/common/svg/secciones/ShowSvgSectionComponent.vue';

    export default {
        components: {ShowSvgSectionComponent},
        props: {
            zonas: {
                type: Array,
                required: true
            }, 
            seccion: {
                type: Object,
                required: true
            },
            zona_id: {
                type: Number,
                required: false
            }
        },
        data() {
            return {
                svg : null,
            }            
        },
        created() {
            this.getSvgCode();
        },
        computed: {
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            recinto() {
                return this.$store.getters.getRecinto;
            }
        },
        methods : {
            getSvgCode() {
                this.loading = true;

                const params = {
                    filters: {},
                    seccion_id: this.seccion.id,
                    recinto_id: this.recinto.id,
                    lista_id: this.lista_abonados.id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.abonos.taquilla.recinto.secciones.regiones.svg'), params).then(res => {
                    this.svg = res.data.svg;
                });
            },
        
            clickRegion(zona) {
                this.$emit('clickZona', zona);           
            }
        }
    }
</script>